import { render } from "./ProjectLogHistoryListPage.vue?vue&type=template&id=20d0faec&scoped=true&ts=true"
import script from "./ProjectLogHistoryListPage.vue?vue&type=script&lang=ts"
export * from "./ProjectLogHistoryListPage.vue?vue&type=script&lang=ts"

import "./ProjectLogHistoryListPage.vue?vue&type=style&index=0&id=20d0faec&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d0faec"]])

export default __exports__